<template>
  <div id="contenedor-main-licitacion-fallo">
    <listado :licitacionParticipantes="getlicitacionParticipantes" />
    <v-dialog
      v-if="esteParticipante"
      v-model="mostrarVentanaAgregarFallo"
      width="900">
      <agregar-fallo
        :participanteLicitacion="esteParticipante"
        :existeGanador="existeGanador"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
    <v-dialog
      v-if="esteParticipante"
      v-model="mostrarVentanaEditarFallo"
      width="900">
      <editar-fallo
        :participanteLicitacion="esteParticipante"
        :existeGanador="existeGanador"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';
import AgregarFallo from '@/components/administracion/licitaciones/fallo/Nuevo.vue';
import EditarFallo from '@/components/administracion/licitaciones/fallo/Editar.vue';

export default {
  name: 'MainLicitacionFallos',
  components: {
    Listado,
    AgregarFallo,
    EditarFallo,
  },

  data() {
    return {
      mostrarVentanaAgregarFallo: false,
      mostrarVentanaEditarFallo: false,
      esteParticipante: null,
      existeGanador: null,
      idLicitacion: this.$route.params.idLicitacion,
    };
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  methods: {
    cerrarVentana() {
      this.mostrarVentanaEditarFallo = false;
      this.mostrarVentanaAgregarFallo = false;
      this.esteParticipante = null;
      this.hayGanador = null;
    },
  },
  computed: {
    getlicitacionParticipantes() {
      if (!this.licitacionParticipantes) return [];
      return this.licitacionParticipantes;
    },
  },
  mounted() {
    eventBus.$on('agregar-fallo-participante', (participanteLicitacion, hayGanador) => {
      this.esteParticipante = participanteLicitacion;
      this.existeGanador = hayGanador;
      this.mostrarVentanaAgregarFallo = true;
    });
    eventBus.$on('editar-fallo-participante', (participanteLicitacion, hayGanador) => {
      this.esteParticipante = participanteLicitacion;
      this.existeGanador = hayGanador;
      this.mostrarVentanaEditarFallo = true;
    });
  },
};
</script>

<style lang="scss">
</style>
